export interface UserProfile {
  Id: string;
  FirstName: string;
  LastName: string;
  Username: string;
  Email: string;
  PhoneNumber: string;
  RoleId: string;
  DefaultLanguage: string;
  Role: Role;
  Status: string;
  ProfilePic: string;
  Location: string;
  ReportTo: string;
  IsEmailVerified: boolean;
  IsSMSVerified: boolean;
  Campaigns: Array<UserCampaign> ;
  MultiFactor: MultiFactor;
}

export interface UserCampaign {
  Id: string;
  Name: string;
  Code: string;
}

export interface ReportTo {
  Id: string;
  Name: string;
}

export interface Role {
  Name: string;
}

export interface MultiFactor {
  IsAppBasedEnabled: boolean;
  IsPasskeyEnabled: boolean;
  IsEmailEnabled: boolean;
  IsSMSEnabled: boolean;
  IsRecoveryCodeGenerated: boolean;
  RecoveryCode: string;
}

export enum MFATypes {
  None,
  AppBased,
  Passkey,
  Email,
  SMS
}
